import { forwardRef } from 'react'

import { breakpoints } from 'styles/mq'
import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import AlphabetLarge from './assets/alphabet.svg'
import AlphabetMobile from './assets/alphabet_mobile.svg'
import { Figcaption, Figure, ImageWrapper, StyledActiveArea } from './styled'
import { Sound } from 'components/alphabet/sound'

const chars = ['ҥ', 'ҕ', 'Дь', 'нь', 'ө', 'ү', 'һ']

export const Alphabet = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="алфавит">Алфавит</Title>

      <p>
        В рамках христианизации территорий русские миссионеры в XIX веке начали
        переводить богослужебные книги на язык саха. Для этого они попытались
        создать алфавит на основе кириллицы. Однако выпущенные варианты букварей
        были неудачными и не смогли передать всю многогранность звуков языка.
        Новый вариант на основе латиницы создал языковед саха Семен Новгородов в
        1917 году. Он заложил в основу принцип "как слышится, так и пишется". В
        1929 году советские власти перевели алфавит Новгородова на
        унифицированную латиницу, а в 1930-х с началом политики русификации – на
        кириллицу.
      </p>
      <p>
        Так выглядит современный саха-алфавит. Чтобы услышать, как произносятся
        некоторые буквы, наведите курсор.
      </p>

      <ImageWrapper>
        <Figure>
          <picture>
            <source srcSet={AlphabetLarge} media={breakpoints.medium} />
            <img src={AlphabetMobile} alt="Alphabet" />
          </picture>
          <Figcaption>
            Голос –
            <a href="https://www.instagram.com/aldanaduoraan/" target="_blank">
              хомусистки
            </a>{' '}
            саха Алданы Дуораан
          </Figcaption>
        </Figure>

        {chars.map((char, index) => (
          <Sound
            key={index}
            char={char}
            chapter="caxa"
            ActiveAreaComponent={StyledActiveArea}
          />
        ))}
      </ImageWrapper>
    </TextContainer>
  </Section>
))
